import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card, Spinner, Alert } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { apiGet } from '../../API/Service/apiClient';
import { decrypt, encrypt } from '../../MIS/encryption';
import { getImageUrl, getUrl_PDF } from '../../MIS/Global';

const MainProductCatalogue = () => {
  const navigate = useNavigate()
  const { mpid} = useParams(); // Fetching id parameter from route
  const [catalogueData, setCatalogueData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
    
  useEffect(() => {
    const fetchCatalogue = async() => {
        
      try {
        setLoading(true);
        let id = await decrypt(mpid)
        const response = await apiGet("sub-product", {action:'tree',mpid:id});
        // Adjust API endpoint as per your backend route setup
        
        setCatalogueData(response.data);
        
      } catch (err) {
        setError('An error occurred while fetching the catalogue.');
      } finally {
        setLoading(false);
      }
    };

    if (mpid) {
      fetchCatalogue();
    }
  }, [mpid]);

  

  if (loading) {
    return (
      <Container className="text-center py-5">
        <Spinner animation="border" variant="primary" />
        <p className="text-muted mt-2 small">Loading catalogue...</p>
      </Container>
    );
  }

  if (error) {
    return (
      <Container className="py-4">
        <Alert variant="danger" className="py-2 small">{error}</Alert>
      </Container>
    );
  }

  return (
    <Container className="py-3">
      {catalogueData.map((category) => (
        <div key={category.id} className="mb-4">
          
          {/* Category / Main Title */}
          <div className="border-bottom pb-2 mb-3">
            <h5 className="fw-bold text-dark m-0 fs-6">{category.name}</h5>
          </div>

          {/* Main Products Loop */}
          {category.main_products && category.main_products.map((mainProd) => (
            <div key={mainProd.id} className="mb-3">
              
              {/* Sub Title */}
              <div className="d-flex align-items-center mb-2">
                <span className="badge bg-secondary me-2 px-2 py-1" style={{ fontSize: '0.75rem' }}>Main</span>
                <h6 className="text-secondary fw-semibold m-0 fs-6">{mainProd.name}</h6>
              </div>

              {/* Sub Products Grid (Responsive & Compact Cards) */}
              <Row xs={2} sm={3} md={4} lg={6} className="g-2">
                {mainProd.sub_products && mainProd.sub_products.map((subProd) => (
                  <Col key={subProd.id} 
                    style={{cursor:'pointer'}}
                    onClick={()=>{
                        navigate(`/tbk/${encrypt(subProd?.id)}`)                        
                    }}
                        
                  >
                    <Card className="h-100 shadow-sm border-0 rounded-3 overflow-hidden text-center bg-light">
                      <div className="ratio ratio-1x1 bg-white">
                        <Card.Img 
                          variant="top" 
                          src={getImageUrl(subProd.img)} 
                          alt={subProd.name}
                          className="object-fit-contain p-2"
                        />
                      </div>
                      <Card.Body className="p-2 d-flex flex-column justify-content-center">
                        <Card.Title 
                          className="text-truncate fw-normal text-dark mb-0" 
                          style={{ fontSize: '0.75rem', lineHeight: '1.2' }}
                          title={subProd.name}
                        >
                          {subProd.name}
                        </Card.Title>
                      </Card.Body>
                    </Card>
                  </Col>
                ))}
              </Row>

            </div>
          ))}

        </div>
      ))}
    </Container>
  );
};

export default MainProductCatalogue;